import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { BucketVencimiento } from '@adelante/shared';

type ConfigBucket = {
  variant: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
};

const config: Record<BucketVencimiento, ConfigBucket> = {
  Vencido: { variant: 'destructive' },
  'Esta semana': {
    variant: 'outline',
    className: 'border-transparent bg-yellow-100 text-yellow-900 hover:bg-yellow-100/80',
  },
  'Próxima semana': {
    variant: 'outline',
    className:
      'border-transparent bg-adelante-primary/20 text-adelante-primary-dark hover:bg-adelante-primary/30',
  },
  '2-4 semanas': { variant: 'secondary' },
  '30-60 días': { variant: 'outline' },
  '60+ días': { variant: 'outline', className: 'text-muted-foreground' },
};

interface Props {
  bucket: BucketVencimiento;
  className?: string;
}

export function BucketVencimientoBadge({ bucket, className }: Props) {
  const c = config[bucket];
  return (
    <Badge variant={c.variant} className={cn(c.className, className)}>
      {bucket}
    </Badge>
  );
}
